import React, { useEffect, useState } from "react";
import MedicinesIcon from "../../../assets/images/medication.svg";
import axiosInstance from "../../../axios/axios";
import { useParams } from "react-router-dom";
import moment from "moment";

import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";

const MedicationsCard = ({ onExportData }) => {
  const params = useParams();

  const [data, setData] = useState([]);

  const StatusClass = (St) => {
    if (St === "Inactive") {
      return "inactive-status";
    } else {
      return "active-status";
    }
  };

  const getProblemsData = () => {
    let currentData = "pid=" + params.pid;

    let encryptedData = Encrypt_Value(currentData, "vozo");

    axiosInstance
      .get("/vozo/patient/medication?search=" + encryptedData)
      .then((response) => {
        let decodingResponse = Decrypt_Value(response.data, "vozo");

        const formatted = (
          Array.isArray(decodingResponse) ? decodingResponse : []
        ).map((item) => ({
          medicationName:
            item.drug_name && item.dosage
              ? `${item.drug_name} ${item.dosage}mg`
              : item.drug_name || "-",

          prescribedDate:
            item.begdate && item.begdate !== "0000-00-00"
              ? moment(item.begdate).format("MMM DD, YYYY")
              : "-",

          status: item.Status || "-",
        }));

        /* UI → latest 3 */

        const latestThree = formatted.slice(0, 3);

        setData(latestThree);

        /* PARENT → FULL DATA */

        if (onExportData) {
          onExportData(
            formatted.map((item) => ({
              title: item.medicationName,
              subText: item.prescribedDate,
              status: item.status,
            })),
          );
        }
      })
      .catch(() => {
        setData([]);
      });
  };

  useEffect(() => {
    getProblemsData();
  }, [params.pid]);

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <img
          src={MedicinesIcon}
          alt="Medicines"
          className="care-summary-main-icon"
        />

        <h3 className="care-summary-title">Current Medications</h3>
      </div>

      <div className="care-summary-body">
        {data.length === 0 ? (
          <div className="care-summary-empty">No Medications Added</div>
        ) : (
          data.map((item, index) => (
            <div
              key={index}
              className={`care-summary-row ${
                index !== data.length - 1 ? "care-summary-border" : ""
              }`}
            >
              <div className="care-summary-content">
                <div className="care-summary-heading">
                  {item.medicationName}
                </div>

                <div className="care-summary-subtext">
                  Prescribed: {item.prescribedDate}
                </div>
              </div>

              <div
                className={`care-summary-status-wrap ${StatusClass(
                  item.status,
                )}`}
              >
                <span className="care-summary-status-dot"></span>

                <span className="care-summary-status-text">{item.status}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(MedicationsCard);
